import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createCommentVNode as _createCommentVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_x_menu_item = _resolveComponent("x-menu-item");
  const _component_a_sub_menu = _resolveComponent("a-sub-menu");
  const _component_a_menu_item = _resolveComponent("a-menu-item");
  return Array.isArray($props.item.children) && $props.item.children.length ? (_openBlock(), _createBlock(_component_a_sub_menu, {
    key: $props.item.name || $props.name,
    title: $props.item.title
  }, _createSlots({
    title: _withCtx(() => [_createElementVNode("span", null, _toDisplayString($props.item.title), 1)]),
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.item.children, (subItem, idx) => {
      return _openBlock(), _createBlock(_component_x_menu_item, {
        key: idx,
        name: subItem.name || `${$props.name}_${idx}`,
        item: subItem,
        onItemClick: $setup.handleItemClick
      }, null, 8, ["name", "item", "onItemClick"]);
    }), 128))]),
    _: 2
  }, [$props.item.icon ? {
    name: "icon",
    fn: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent($setup.itemIcon)))]),
    key: "0"
  } : undefined]), 1032, ["title"])) : (_openBlock(), _createBlock(_component_a_menu_item, {
    key: $props.item.name || $props.name,
    onClick: $setup.handleClick
  }, _createSlots({
    default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString($props.item.title), 1)]),
    _: 2
  }, [!!$props.item.icon ? {
    name: "icon",
    fn: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent($setup.itemIcon)))]),
    key: "0"
  } : undefined]), 1032, ["onClick"]));
}